import { render } from "./DashboardWidget.vue?vue&type=template&id=5ed98a03&ts=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=ts"
export * from "./DashboardWidget.vue?vue&type=script&lang=ts"

import "./DashboardWidget.vue?vue&type=style&index=0&id=5ed98a03&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__